import { Component } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GlobalService } from "../../services/global.service";
import { MasterService } from "../../services/master.service";
import { Inject } from "@angular/core";

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})

export class ConfirmationPopupComponent {
  selectedReason: string;
  otherReason: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      serviceId: number;
      serviceName: string;
      willBeEnabled: boolean;
      location: string;
      serviceType?: number | string;
      isInternalService?: boolean;
      isActive?: boolean;
    }
  ) {}

  confirmAction() {
    this.dialogRef.close({
      confirmed: true,
      serviceId: this.data.serviceId,
      willBeEnabled: this.data.willBeEnabled,
      reason: this.selectedReason,
      otherReason: this.selectedReason === 'Other' ? this.otherReason : '',
      serviceType: this.data.serviceType,
      isInternalService: this.data.isInternalService,
      isActive: this.data.isActive
    });
  }

  cancelAction() {
    this.dialogRef.close({ confirmed: false });
  }
}